// File: src/components/Charts/BarChart.jsx
import React from 'react';
import {
  ResponsiveContainer,
  BarChart as ReBarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Cell,
} from 'recharts';

const COLORS = {
  critical: '#6A0DAD',  // Purple for high dropoff
  warning: '#F59E0B',   // Orange for medium
  good: '#00A8A9',      // Teal for low
};

const getBarColor = (value) => {
  if (value > 70) return COLORS.critical;
  if (value > 40) return COLORS.warning;
  return COLORS.good;
};

const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    return (
      <div style={{
        background: 'white',
        padding: '8px 12px',
        border: '1px solid #e5e7eb',
        borderRadius: 6,
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
      }}>
        <p style={{ margin: 0, fontWeight: 600, fontSize: 13 }}>{label}</p>
        <p style={{ margin: '4px 0 0', fontSize: 12, color: '#6b7280' }}>
          {payload[0].value.toFixed(1)}% dropoff
        </p>
      </div>
    );
  }
  return null;
};

export default function BarChart({ data, height = '100%' }) {
  // Handle empty or invalid data
  if (!data || data.length === 0) {
    return (
      <div style={{ 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center', 
        height: '100%',
        color: '#6b7280'
      }}>
        No data available
      </div>
    );
  }

  return (
    <ResponsiveContainer width="100%" height={height}>
      <ReBarChart data={data} layout="vertical" margin={{ left: 20, right: 20 }}>
        <CartesianGrid strokeDasharray="3 3" horizontal={true} vertical={false} />
        <XAxis 
          type="number" 
          domain={[0, 100]} 
          tickFormatter={(v) => `${v}%`}
          fontSize={11}
        />
        <YAxis 
          type="category" 
          dataKey="name" 
          width={100}
          fontSize={11}
          tickLine={false}
        />
        <Tooltip content={<CustomTooltip />} />
        <Bar dataKey="value" radius={[0, 4, 4, 0]}>
          {data.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={getBarColor(entry.value)} />
          ))}
        </Bar>
      </ReBarChart>
    </ResponsiveContainer>
  );
}